import { setRequestingSubtitles } from '../subtitles/actions.any';
/**
 * Force-enables local caption display for a working captioner.
 *
 * The middleware only renders transcription results while
 * `_requestingSubtitles` is on, and viewers normally reach that state through
 * the enabledByDefault preference or the CC dialog. A captioner composing in
 * the room must see their own output regardless of those settings — publishing
 * blind is how mis-captions ship.
 *
 * Called repeatedly from an effect; no-ops once display is already on.
 * Language is passed as null so no translation-language participant property
 * is set: the captioner sees every result unfiltered.
 *
 * @param {Function} dispatch - Redux dispatch.
 * @param {IEnsureCaptionDisplayOptions} options - Conference/display state.
 * @returns {boolean} - True when display was turned on by this call.
 */
export function ensureLocalCaptionDisplay(dispatch, { conferenceJoined, requestingSubtitles }) {
    if (!conferenceJoined || requestingSubtitles) {
        return false;
    }
    dispatch(setRequestingSubtitles(true, true, null));
    return true;
}
